import React from 'react';

function footer(props) {
    return (
        
        <footer className="bg-dark text-light py-3">
            
                <div className="footer__contact">
                <h6>Address</h6>
                <p>Malad(E)
                    Mumbai-400097
                </p>
                

                <h6>Contacts</h6>
                <p >Email:-shubhamyadav7303@gmail.com<br></br>
                    Phone:7303166700
                </p>
               

            
                <p className="text-center">
                 &copy;Copyright 2021 Shubham - All Rights Reserved

                
                </p>
                <a href="cityweather.netlify.app">Weather-Checker</a>
                </div>

            </footer>
    );
}

export default footer;